import { useCallback } from "react";
import { allRegexMapper } from "../utils/regex.utils";
import { HFieldProps } from "../index";

export type UseTextControlPatternValidationType = {
  textControlPattern?: HFieldProps["textControlPattern"];
};
const useTextControlPatternValidation = ({
  textControlPattern,
}: UseTextControlPatternValidationType) => {
  const isTextPatternValid = useCallback(
    (value: string) => {
      return (textControlPattern || []).every(pattern => {
        const regex = allRegexMapper[pattern];
        if (regex) {
          const isValid = regex.test(value);
          return isValid;
        }
        return true;
      });
    },
    [textControlPattern],
  );
  return { isTextPatternValid };
};

export { useTextControlPatternValidation };
